import { dsnToString } from '../utils-hoist/dsn.js';
import { createEnvelope } from '../utils-hoist/envelope.js';
import { logger } from '../utils-hoist/logger.js';
import { serializeMetricBuckets } from './utils.js';

/**
 * Captures aggregated metrics to the supplied client.
 */
function captureAggregateMetrics(client, metricBucketItems) {
  logger.log("Flushing aggregated metrics, number of metrics: ".concat(metricBucketItems.length));
  var dsn = client.getDsn();
  var metadata = client.getSdkMetadata();
  var tunnel = client.getOptions().tunnel;
  var metricsEnvelope = createMetricEnvelope(metricBucketItems, dsn, metadata, tunnel);

  // sendEnvelope should not throw
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  client.sendEnvelope(metricsEnvelope);
}

/**
 * Create envelope from a metric aggregate.
 */
function createMetricEnvelope(metricBucketItems, dsn, metadata, tunnel) {
  var headers = {
    sent_at: new Date().toISOString()
  };
  if (metadata && metadata.sdk) {
    headers.sdk = {
      name: metadata.sdk.name,
      version: metadata.sdk.version
    };
  }
  if (!!tunnel && dsn) {
    headers.dsn = dsnToString(dsn);
  }
  var item = createMetricEnvelopeItem(metricBucketItems);
  return createEnvelope(headers, [item]);
}
function createMetricEnvelopeItem(metricBucketItems) {
  var payload = serializeMetricBuckets(metricBucketItems);
  var metricHeaders = {
    type: 'statsd',
    length: payload.length
  };
  return [metricHeaders, payload];
}
export { captureAggregateMetrics, createMetricEnvelope };